import type { RequestException } from '@eika-infrastruktur/request';
import type { NameAndUrl } from '@generated-types';
import { getPdfNameAndUrl } from '@react-query/services/pdf';
import type { PdfKey } from '@react-query/types';
import { useQuery } from '@tanstack/react-query';

export const usePdfNameAndUrl = (pdfKey: PdfKey) => {
    return useQuery<NameAndUrl, RequestException>({
        queryKey: ['pdf', pdfKey],
        queryFn: () => getPdfNameAndUrl(pdfKey),
    });
};
